/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The GoalsGoalTargetsAttributes model module.
 * @module model/GoalsGoalTargetsAttributes
 * @version v0.3
 */
export default class GoalsGoalTargetsAttributes {
  /**
   * Constructs a new <code>GoalsGoalTargetsAttributes</code>.
   * @alias module:model/GoalsGoalTargetsAttributes
   * @class
   * @param targetTemplateId {String} ID of the target template being used to create the target
   */
  constructor(targetTemplateId) {
    this.targetTemplateId = targetTemplateId;
  }

  /**
   * Constructs a <code>GoalsGoalTargetsAttributes</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/GoalsGoalTargetsAttributes} obj Optional instance to populate.
   * @return {module:model/GoalsGoalTargetsAttributes} The populated <code>GoalsGoalTargetsAttributes</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new GoalsGoalTargetsAttributes();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('description'))
        obj.description = ApiClient.convertToType(data['description'], 'String');
      if (data.hasOwnProperty('value'))
        obj.value = ApiClient.convertToType(data['value'], 'String');
      if (data.hasOwnProperty('target_template_id'))
        obj.targetTemplateId = ApiClient.convertToType(data['target_template_id'], 'String');
      if (data.hasOwnProperty('observation_type_id'))
        obj.observationTypeId = ApiClient.convertToType(data['observation_type_id'], 'String');
      if (data.hasOwnProperty('tag_list'))
        obj.tagList = ApiClient.convertToType(data['tag_list'], ['String']);
    }
    return obj;
  }
}

/**
 * Name of the goal target. If not provided, defaults to the target template's name.
 * @member {String} name
 */
GoalsGoalTargetsAttributes.prototype.name = undefined;

/**
 * Description of the target. If not provided, defaults to the target template's description.
 * @member {String} description
 */
GoalsGoalTargetsAttributes.prototype.description = undefined;

/**
 * The target value. If not provided, defaults to the target template's value.
 * @member {String} value
 */
GoalsGoalTargetsAttributes.prototype.value = undefined;

/**
 * ID of the target template being used to create the target
 * @member {String} targetTemplateId
 */
GoalsGoalTargetsAttributes.prototype.targetTemplateId = undefined;

/**
 * ID of the relevant observation type. Defaults to the observation type of the measure or target template being used.
 * @member {String} observationTypeId
 */
GoalsGoalTargetsAttributes.prototype.observationTypeId = undefined;

/**
 * Add an array of strings to help manage your resources
 * @member {Array.<String>} tagList
 */
GoalsGoalTargetsAttributes.prototype.tagList = undefined;

